import { useMemo } from 'react';
import { compareAsc, max, min } from 'date-fns';
import { useBusinessHoursProps } from '../../business-hours-props-context';
import type { SettingsSpecialInterval } from './settings-special-interval';

export function useSettingsSpecialIntervals(): SettingsSpecialInterval[] {
  const { specialIntervals } = useBusinessHoursProps();

  return useMemo(
    () =>
      specialIntervals
        .flatMap((day) => {
          const endDate = max([
            new Date(`${day.startDate.date}T00:00`),
            new Date(`${day.endDate.date}T00:00`)
          ]);
          const startDate = min([
            new Date(`${day.startDate.date}T00:00`),
            new Date(`${day.endDate.date}T00:00`)
          ]);

          return {
            id: day.id,
            dates: [startDate, endDate] as [Date, Date],
            settingsHours: day.workingHours || [],
            isClosed: day.type === 'closed',
            description: day.description
          };
        })
        .sort((a, b) => compareAsc(a.dates[0], b.dates[0])),
    [specialIntervals]
  );
}
